if (!customElements.get('product-form')) {
  customElements.define('product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.errorListenerCreated = false;

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.error = this.querySelector('.product__error');
        this.submitButton = this.querySelector('[type="submit"]');

        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      }

      onSubmitHandler(e) {
        e.preventDefault();

        if (!this.errorListenerCreated) {
          this.errorListenerCreated = true;

          document.addEventListener(`cart-error-${ this.variantIdInput.value }`, e => {
            const { detail: { status, description } } = e;

            this.error.innerText = description;

            setTimeout(() => this.error.innerText = '', 6000);
          });
        }

        document.dispatchEvent(new CustomEvent('cart:add', {
          detail: {
            el: this,
            id: this.variantIdInput.value,
            items: [{ id: this.variantIdInput.value, quantity: this.quantityInput.value }]
          }
        }));

        setTimeout(() => {
          this.querySelector('.minus')?.classList.add('disabled');
          this.quantityInput.value = 1;
        }, 300);
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }

      get quantityInput() {
        return this.form.querySelector('[name=quantity]');
      }
    }
  );
}
